<template>
  <el-row class="color-table">
    <el-col>
      <el-form ref="basicForm" inline label-position="left">
        <el-form-item label=" ">
          <div style="display: flex">
            <div>
              <el-radio-group v-model="colorType" no="19">
                <el-radio :label="0">{{ $t('CargoMsg.Cargo_BusinessStatus') }}</el-radio>
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_FinancialStatus') }}</el-radio>
              </el-radio-group>
            </div>
            <div style="padding-left: 50px">
              <el-tooltip
                class="item"
                :content="$t('CargoMsg.Cargo_FinancialColorTip')"
                placement="top"
                effect="light"
                style="color: #4AA4EA"
              >
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;" />
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col v-show="colorType === 0">
      <el-table :data="colorData">
        <el-table-column
          v-if="langue"
          prop="colorName"
          :label="$t('Tool.StatusName')"
        />
        <el-table-column
          v-else
          prop="colorEnglishName"
          :label="$t('Tool.StatusName')"
        />
        <el-table-column
          prop="colorValue"
          :label="$t('Tool.ColorValue')"
          align="right"
        >
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.colorValue" />
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col v-show="colorType === 1">
      <el-table :data="financeColorData">
        <el-table-column
          v-if="langue"
          prop="colorName"
          :label="$t('Tool.StatusName')"
        />
        <el-table-column
          v-else
          prop="colorEnglishName"
          :label="$t('Tool.StatusName')"
        />
        <el-table-column
          prop="colorValue"
          :label="$t('Tool.ColorValue')"
          align="right"
        >
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.colorValue" :disabled="toExoSystemHc" />
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <el-col class="color-save-btn">
      <el-button type="primary" @click="handleSave">{{ $t('Tool.Save') }}</el-button>
    </el-col>
  </el-row>
</template>

<script>
import lodash from 'lodash'
import { getUserInfo } from '@/utils/auth'
import { getPersonQueryConfig, savePersonQueryConfig } from '@/api/commonComponent'
import { getLoading } from '@/utils/utilBaseElement'
import store from '@/store'
import { cache, cacheName } from '@/utils/cacheManager'
export default {
  name: 'ColorSetting',
  data() {
    return {
      loading: null,
      colorType: 0,
      toExoSystemHc: false
    }
  },
  computed: {
    colorData() {
      return lodash.cloneDeep(this.$store.state.settings.colorSettings)
    },
    financeColorData() {
      return lodash.cloneDeep(this.$store.state.settings.financeColorSettings)
    },
    langue() {
      return this.$store.getters.language === 'zh'
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.toExoSystemHc = String(cache.config.get('ToExoSystem')) === 'HC'
    this.reloadType()
  },
  methods: {
    handleSave() {
      this.loading = getLoading('color-table')
      console.log(this.partnerConfigList)
      const currentUserInfo = getUserInfo()
      let data = {}
      if (this.colorType === 1) {
        data = {
          bDefault: true,
          configModule: '10088',
          configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10088`,
          configType: 3, // 固定值，表格配置
          configContent: JSON.stringify(this.financeColorData)
        }
        this.$store.dispatch('settings/changeSetting', { key: 'financeColorSettings', value: this.financeColorData })
      } else {
        data = {
          bDefault: true,
          configModule: '10087',
          configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10087`,
          configType: 3, // 固定值，表格配置
          configContent: JSON.stringify(this.colorData)
        }
        this.$store.dispatch('settings/changeSetting', { key: 'colorSettings', value: this.colorData })
      }
      savePersonQueryConfig(data).then(res => {
        this.$message.success(this.$t('Tool.SaveSucceed'))
        const typeData = {
          bDefault: true,
          configModule: '10089',
          configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10089`,
          configType: 3, // 固定值，表格配置
          configContent: this.colorType
        }
        this.$store.dispatch('settings/changeSetting', { key: 'colorType', value: this.colorType })
        savePersonQueryConfig(typeData)
      }).finally(() => {
        this.loading.close()
      })
    },
    reloadType() {
      this.colorType = lodash.cloneDeep(Number(this.$store.state.settings.colorType))
    },
    reload() {
      this.loading = getLoading('color-table')
      const currentUserInfo = getUserInfo()
      const data = {
        bDefault: true,
        configModule: '10087',
        configName: `local_uiDoc_person_colorModule_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10087`,
        configType: 3, // 固定值，表格配置
        configBy: currentUserInfo.userId,
        tenantId: currentUserInfo.tenantId
      }
      getPersonQueryConfig(data).then(res => {
        const { data } = res
        const defaultConfig = data.find(item => item.bDefault)
        if (defaultConfig && defaultConfig.configContent) {
          const cacheConfig = store.state.settings.colorSettings
          const remoteConfigs = JSON.parse(defaultConfig.configContent)
          console.log('settings/changeSetting', remoteConfigs)
          const configMerged = cacheConfig.reduce((result, config) => {
            const newConfig = { ...config }
            Object.keys(newConfig).forEach(key => {
              const remoteConfig = remoteConfigs.find(conf => conf.colorKey === config.colorKey)
              if (key !== 'colorKey' && remoteConfig && remoteConfig[key] !== undefined) {
                newConfig[key] = remoteConfig[key]
              }
            })
            result.push(newConfig)
            return result
          }, [])
          this.$store.dispatch('settings/changeSetting', { key: 'colorSettings', value: configMerged })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.color-table{
  padding: 10px 60px 5px 60px;
  /deep/ .el-table{
    th{
      height: 40px;
      color: #000;
      .cell{
        font-size: 13px;
      }
    }
    td{
      &:first-of-type{
        .cell{
          text-indent: 5px;
          font-size: 13px;
        }
      }
      .el-color-picker{
        vertical-align: middle;
        .el-color-picker__trigger{
          border: none;
          .el-color-picker__color{
            border: none;
            .el-color-picker__color-inner{
              border: 1px solid #E3E7ED;
              border-radius: 4px;
            }
          }
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
  .color-save-btn{
    padding-top: 20px;
    text-align: center;
    .el-button{
      width: 120px;
      background-color: #409EFF;
      border-color: #409EFF;
    }
  }
}
</style>
